/* Keep Minimog sliders and breakpoint flags in sync when the viewport
   changes without a reload (Chrome device mode, rotate, split screen).
   matchMedia.onchange is skipped by some DevTools resizes; resize is not. */
(function () {
  var timer = 0;
  var lastWidth = window.innerWidth;
  function isMobile() {
    return window.matchMedia('screen and (max-width: 767px)').matches;
  }
  function isTablet() {
    return window.matchMedia('screen and (max-width: 1023px)').matches;
  }
  function syncBreakpoints() {
    var theme = window.MinimogTheme;
    if (!theme || !theme.config) return;
    var mobile = isMobile();
    if (mobile !== theme.config.mqlMobile) {
      theme.config.mqlMobile = mobile;
      document.dispatchEvent(new CustomEvent(mobile ? 'matchMobile' : 'unmatchMobile'));
      document.querySelectorAll('media-gallery').forEach(function (mg) {
        if (typeof mg.updateMediaLayout === 'function') {
          try { mg.updateMediaLayout(); } catch (e) {}
        }
      });
    }
    var tablet = isTablet();
    if (tablet !== theme.config.mqlTablet) {
      theme.config.mqlTablet = tablet;
      document.dispatchEvent(new CustomEvent(tablet ? 'matchTablet' : 'unmatchTablet'));
    }
  }
  function stripSlide(slide) {
    slide.style.width = '';
    slide.style.marginRight = '';
    slide.style.marginLeft = '';
  }
  function updateSwipers() {
    document.querySelectorAll('.swiper-container, .swiper').forEach(function (el) {
      var s = el.swiper;
      if (s && typeof s.update === 'function') {
        try { s.update(); } catch (e) {}
      }
    });
    var mobile = isMobile();
    // Read every width first, then write: interleaving forced a layout per slide.
    var strip = [];
    document.querySelectorAll('.swiper-slide').forEach(function (slide) {
      if (slide.closest('.m-media-gallery, .m-product-media, .nav-swiper-container')) return;
      var rec = slide.closest('product-recommendations, m-recently-viewed, .m-mixed-layout--mobile-scroll, m-featured-collection, m-handpicked-products, .m-product-list');
      if (!rec) return;
      if (mobile) { strip.push(slide); return; }
      var w = slide.offsetWidth || parseFloat(slide.style.width) || 0;
      if (w > window.innerWidth * 0.92) strip.push(slide);
    });
    strip.forEach(stripSlide);
    document.querySelectorAll('.m-mixed-layout--mobile-scroll .m-mixed-layout__inner, .m-mixed-layout--mobile-scroll .swiper-wrapper').forEach(function (el) {
      el.style.transform = '';
    });
  }
  function run() {
    // Mobile toolbars collapsing, the on-screen keyboard and synthetic resize
    // events change only the height; re-laying out every slider then is pure INP cost.
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    syncBreakpoints();
    updateSwipers();
  }
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(run, 80);
  }
  window.addEventListener('resize', queue);
  window.addEventListener('orientationchange', queue);
  if (window.visualViewport) visualViewport.addEventListener('resize', queue);
})();
